import { z } from "zod";
export const npdCalculationResultParameterDecimalPlacesDtoSchema = z.union([z.number().int(), z.literal("auto")]);
